/* Recommended Products
   Client-side multi-select filtering + optional "Load more".
   Scoped per-instance via a custom element, so multiple sections on one page
   each manage their own state. Progressive enhancement: with JS disabled,
   every card stays visible and no controls break. */

(function () {
  if (customElements.get('recommended-products')) return;

  class RecommendedProducts extends HTMLElement {
    connectedCallback() {
      this.pills = Array.from(this.querySelectorAll('.recommended-products__pill'));
      this.cards = Array.from(this.querySelectorAll('[data-card]'));
      this.emptyEl = this.querySelector('[data-empty]');
      this.moreBtn = this.querySelector('[data-more]');

      this.limit = parseInt(this.dataset.limit, 10) || 0;
      this.active = new Set();   /* empty = "All" */
      this.page = 1;             /* how many "pages" of `limit` are revealed */

      this.pills.forEach((pill) => {
        pill.addEventListener('click', () => this.onPillClick(pill));
      });

      if (this.moreBtn) {
        this.moreBtn.addEventListener('click', () => {
          this.page += 1;
          this.render();
        });
      }

      this.render();
    }

    onPillClick(pill) {
      const type = pill.dataset.type;

      if (type === 'all') {
        this.active.clear();
      } else if (this.active.has(type)) {
        this.active.delete(type);
      } else {
        this.active.add(type);
      }

      this.page = 1;
      this.render();
    }

    cardMatches(card) {
      if (this.active.size === 0) return true;
      const types = (card.dataset.types || '').split(' ').filter(Boolean);
      return types.some((t) => this.active.has(t));
    }

    render() {
      /* Pill active states + aria */
      this.pills.forEach((pill) => {
        const isActive =
          pill.dataset.type === 'all'
            ? this.active.size === 0
            : this.active.has(pill.dataset.type);
        pill.classList.toggle('is-active', isActive);
        pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      /* Determine matches, then apply the optional reveal cap */
      const matched = [];
      this.cards.forEach((card) => {
        if (this.cardMatches(card)) {
          matched.push(card);
        } else {
          card.hidden = true;
        }
      });

      const cap = this.limit > 0 ? this.limit * this.page : matched.length;
      matched.forEach((card, i) => {
        card.hidden = i >= cap;
      });

      /* Empty state */
      if (this.emptyEl) this.emptyEl.hidden = matched.length > 0;

      /* Load more visibility */
      if (this.moreBtn) {
        this.moreBtn.hidden = !(this.limit > 0 && matched.length > cap);
      }
    }
  }

  customElements.define('recommended-products', RecommendedProducts);
})();